module.exports = __webpack_public_path__ + "static/media/hotlist.0b531c76.svg";